export default function() {
  $(window).scroll(function(){

    if ($(window).scrollTop() >= 50) {
      $('.social').addClass('not-visible');
      $('#logo__article').addClass('is-small');
      $('.logo').addClass('is-small');
    }
    else {
      $('.social').removeClass('not-visible');
      $('#logo__article').removeClass('is-small');
      $('.logo').removeClass('is-small');
    }
  });
}



// WEBPACK FOOTER //
// ./source/assets/javascripts/initScroll.js